import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { withHooks } from '../../../shared/lib/withHooks';

type State = {
  actionPanelVisible: boolean;
  showActionPanel: () => void;
  hideActionPanel: () => void;
};

const StateContext = createContext<State>({
  actionPanelVisible: false,
  showActionPanel() {},
  hideActionPanel() {},
});

export const useActionPanelState = () => useContext(StateContext);

export const withActionPanelState = withHooks(() => ({
  actionPanelState: useActionPanelState(),
}));

export class ActionPanelState extends React.Component {
  /* eslint-disable react/sort-comp */
  static propTypes = {
    children: PropTypes.node,
  };

  showActionPanel = () => this.setState({ actionPanelVisible: true });
  hideActionPanel = () => this.setState({ actionPanelVisible: false });

  state: State = {
    actionPanelVisible: false,
    showActionPanel: this.showActionPanel,
    hideActionPanel: this.hideActionPanel,
  };

  render() {
    return (
      <StateContext.Provider value={this.state}>
        {this.props.children}
      </StateContext.Provider>
    );
  }
}
